import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getHomeCms } from '../../api/services/cmsService';

// Async thunk
export const fetchCmsHomeAction = createAsyncThunk(
  'cms/fetchHome',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getHomeCms();
      return response;
    } catch (error) {
      return rejectWithValue(error?.message || 'Failed to fetch CMS home');
    }
  },
  {
    condition: (_, { getState }) => {
      const { loading, home } = getState().cms;
      return !loading && !home;
    },
  }
);

// Initial state
const initialState = {
  home: null,
  loading: false,
  error: null,
};

// Slice
const cmsSlice = createSlice({
  name: 'cms',
  initialState,
  reducers: {
    clearCmsError: (state) => {
      state.error = null;
    },
    clearCmsHome: (state) => {
      state.home = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCmsHomeAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCmsHomeAction.fulfilled, (state, action) => {
        state.loading = false;
        state.home = action.payload;
      })
      .addCase(fetchCmsHomeAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearCmsError, clearCmsHome } = cmsSlice.actions;
export default cmsSlice.reducer;


